import { useEffect, useState } from "react";

const useViewportResize = () => {
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [buttonPadding, setButtonPadding] = useState(40);

  useEffect(() => {
    const handleResize = () => {
      const viewportHeight =
        window.visualViewport?.height || window.innerHeight;
      const screenHeight = window.screen.height;

      setWindowHeight(viewportHeight);
      setButtonPadding(viewportHeight < screenHeight * 0.9 ? 20 : 40);
      setWindowWidth(window.innerWidth);
    };

    window.visualViewport?.addEventListener("resize", handleResize);

    handleResize();

    return () => {
      window.visualViewport?.removeEventListener("resize", handleResize);
    };
  }, []);

  return { windowHeight, buttonPadding, windowWidth };
};

export default useViewportResize;
